import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@aiskills/ui-kit/theme.css";
import { App } from "./App";

const container = document.getElementById("root");
if (!container) {
  throw new Error("#root element missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
